import { useQuery } from '@tanstack/react-query';

import { fetchMe, type MyProfileDTO } from '@/api/adapters/my-profile';

export const MY_PROFILE_QUERY_KEY = ['me', 'profile'] as const;

/**
 * The signed-in staff member's own profile.
 *
 * @param enabled pass `false` to hold the request back while the caller does not need the profile
 *   yet. A screen that keeps a closed dialog mounted would otherwise fetch it on every visit for a
 *   dialog nobody opened; callers that always need it can omit the argument.
 */
export function useMyProfile(enabled = true) {
  return useQuery<MyProfileDTO>({
    queryKey: MY_PROFILE_QUERY_KEY,
    queryFn: fetchMe,
    staleTime: 60_000,
    enabled,
  });
}
